import { Component, inject, signal } from '@angular/core';
import { Router, RouterLink } from '@angular/router';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { Catalog } from '../../../rewards/interfaces/search-catalog-response.interface';

@Component({
  selector: 'app-article-add-success-modal',
  templateUrl: './wishlist-item-added-modal.component.html',
})
export class WishlistItemAddedModalComponent {
  private ngbActiveModal = inject(NgbActiveModal);
  private router = inject(Router);

  article = signal<Catalog | null>(null);

  closeModal() {
    this.ngbActiveModal.close();
  }

  viewWishList() {
    this.closeModal();
    this.router.navigate(['/wishlist']);
  }
}
